<template>
  <v-container fluid class="b-container" @click="handleFocus()">
    <!-- <v-container fluid class="b-container"> -->
    <v-sheet v-show="permission || superUser" min-height="800" color="grey lighten-4">
      <v-card tile flat width="600" class="mx-auto my-3">
        <v-card-title class="text-h5 font-weight-bold px-10 pt-5">
          <v-icon class="text--primary ml-n1 mr-1" large v-text="icons.mdiPlusThick"></v-icon>
          {{ translations.newTransaction[lang] }}
        </v-card-title>

        <v-card-subtitle class="px-10" v-text="translations.info[lang]"></v-card-subtitle>

        <v-divider></v-divider>

        <v-form autocomplete="off" @submit.prevent="createTransaction()" ref="transactionForm">
          <v-row
            no-gutters
            align="center"
            class="px-10 pt-5"
            :class="
              transactionPreview.user_points_info && !isEmpty(transactionPreview.user_points_info)
                ? ''
                : 'b-bottom-outlined pb-5'
            "
          >
            <v-col cols="auto" class="subtitle-1 font-weight-bold pr-5">
              {{ translations.selectUser[lang] }}
              <div
                v-if="!previewLoading"
                style="min-height: 160px; min-width: 100px"
                class="d-flex align-center"
              >
                <v-img
                  src="@/assets/new-transaction-user.png"
                  width="90"
                  class="rounded-circle mt-4"
                ></v-img>
              </div>
              <v-skeleton-loader
                v-else
                min-width="100"
                min-height="160"
                class="ma-0 mt-2 transaction-avatar-loader d-flex align-center"
                v-bind="skeletonAttrs"
                type="avatar"
              ></v-skeleton-loader>
              <div style="height: 2px">
                <v-progress-linear
                  color="secondary"
                  :indeterminate="previewLoading"
                  :active="previewLoading"
                  height="2"
                ></v-progress-linear>
              </div>
            </v-col>

            <v-col class="pl-10">
              <v-alert
                v-model="alert"
                color="#2a3042"
                border="top"
                elevation="2"
                colored-border
                class="mb-4"
              >
                <b>{{ translations.tip[lang] }}</b>
                {{ translations.alertText[lang] }}
              </v-alert>
              <div class="d-flex align-center mobile-cc-container">
                <v-select
                  :items="activeCountries"
                  label="CC*"
                  outlined
                  v-model="transaction.country_id"
                  item-value="country_id"
                  item-text="name"
                  solo
                  flat
                  dense
                  :hide-details="false"
                  color="secondary"
                  item-color="secondary"
                  class="country-code-select mt-3"
                  :success="success.countryCode"
                  :error-messages="error.countryCode"
                  @focus="error.countryCode = ''"
                  @blur="validateCountryCode"
                >
                  <template v-slot:selection="{ item }">
                    <v-row no-gutters class="d-flex align-center">
                      <v-col class="mr-0">
                        <img
                          :src="item.flag"
                          width="25"
                          style="vertical-align: middle"
                          class="mr-0"
                        />
                      </v-col>

                      <v-col cols="auto">{{ item.phone_code }}</v-col>
                    </v-row>
                  </template>
                  <template v-slot:item="{ item }">
                    <v-row no-gutters>
                      <v-col class="mr-3">
                        <img
                          :src="item.flag"
                          width="25"
                          style="vertical-align: middle"
                          class="mr-3"
                        />
                        {{ item.name }} ({{ item.code }})
                      </v-col>

                      <v-col cols="auto">{{ item.phone_code }}</v-col>
                    </v-row>
                  </template>
                </v-select>
                <v-text-field
                  v-model="transaction.user"
                  :label="translations.user[lang]"
                  color="secondary"
                  class="mt-3 user-mobile"
                  outlined
                  dense
                  clearable
                  :hide-details="false"
                  :success="success.user"
                  :error-messages="error.user"
                  @focus="error.user = ''"
                  @blur="validateUser"
                  @click.prevent=""
                  ref="phoneInput"
                  autofocus
                ></v-text-field>
                <div class="mt-n7 pl-3" v-if="showCustomerData">
                  <v-tooltip color="secondary" bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn
                        class="pa-1"
                        icon
                        tile
                        :loading="previewLoading"
                        color="secondary"
                        v-on="on"
                        @click="customerDialog = true"
                      >
                        <v-icon class="pa-2" size="48" v-text="icons.mdiAccountDetails"></v-icon>
                      </v-btn>
                    </template>

                    <span class="font-weight-bold" style="white-space: pre">{{
                      translations.viewData[lang]
                    }}</span>
                  </v-tooltip>
                </div>
              </div>
              <v-col v-if="showNotRegisteredWarning" class="py-0 my-0 pr-14 d-flex justify-end">
                <div class="pr-14 text-caption mt-n9" color="warning">
                  <v-icon
                    color="warning"
                    class="mr-1 mt-n1"
                    style="font-size: 1.2em; vertical-align: middle"
                    >mdi-alert</v-icon
                  ><span class="orange--text text--darken-2 text-capitalize pr-2">{{
                    translations.notRegistered[lang]
                  }}</span>
                </div></v-col
              >
            </v-col>
          </v-row>
          <v-col class="b-bottom-outlined px-6 pb-5 mt-0" v-if="transactionPreview.loyalty_program">
            <v-col sm="12" v-if="!previewLoading" class="pt-0">
              <v-simple-table
                dense
                fixed-header
                height="auto"
                style="max-height: 200px; overflow: auto"
              >
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-right"></th>
                      <th class="text-left">
                        <span class="ml-n4">
                          {{ translations.loyalty[lang] }}
                        </span>
                      </th>
                      <th class="text-center">
                        {{ translations[`current_${storeMode}`][lang] }}
                      </th>
                      <th class="text-center">
                        {{ translations[`new_${storeMode}`][lang] }}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr class="font-weight-bold">
                      <td style="max-width: 32px" class="pr-0 pl-0">
                        <v-img
                          contain
                          height="36"
                          :src="transactionPreview.loyalty_program.logo"
                        ></v-img>
                      </td>
                      <td>
                        {{
                          transactionPreview.loyalty_program.points_label ||
                          (transactionPreview.loyalty_program.name &&
                            transactionPreview.loyalty_program.name[lang])
                        }}
                      </td>
                      <td class="text-center">
                        {{ transactionPreview.current_user_points }}
                      </td>
                      <td class="text-center">
                        {{ transactionPreview.new_user_points }}
                      </td>
                    </tr>
                    <tr
                      v-for="item in transactionPreview.new_user_points_per_loyalty ||
                      transactionPreview.current_user_points_per_loyalty ||
                      []"
                      :key="item.loyalty_program_id"
                    >
                      <td style="max-width: 32px" class="pr-0 pl-0">
                        <v-img contain height="28" :src="item.logo"></v-img>
                      </td>
                      <td>
                        {{ item.points_label || (item.name && item.name[lang]) }}
                      </td>
                      <td class="text-center">
                        {{ getPointsPerLoyalty('current', item.loyalty_program_id) }}
                      </td>
                      <td class="text-center">
                        {{ getPointsPerLoyalty('new', item.loyalty_program_id) }}
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-col>
            <v-skeleton-loader
              v-else
              min-width="300"
              class="ma-3 pt-3"
              v-bind="skeletonAttrs"
              type="sentences"
            ></v-skeleton-loader>
          </v-col>
          <v-col
            class="b-bottom-outlined px-10 pb-5"
            v-if="
              transactionPreview.user_points_info && !isEmpty(transactionPreview.user_points_info)
            "
          >
            <v-col v-if="!previewLoading">
              <div class="subtitle-2 font-weight-medium">
                {{ translations.currentTier[lang] }}
                {{
                  transactionPreview.user_points_info.current_package
                    ? transactionPreview.user_points_info.current_package.title[lang]
                    : '-'
                }}
              </div>

              <div class="subtitle-2 font-weight-medium">
                {{ translations[company.tier.package_mode][lang] }}
                {{ translations.forTheNextTier[lang] }}
                {{
                  transactionPreview.user_points_info.next_package
                    ? transactionPreview.user_points_info.next_package.title[lang]
                    : ''
                }}
                -
                {{
                  transactionPreview.user_points_info.next_package
                    ? transactionPreview.user_points_info.next_package.remaining_points
                    : ''
                }}
              </div>
            </v-col>
            <v-skeleton-loader
              v-else
              min-width="300"
              class="ma-3 pt-3"
              v-bind="skeletonAttrs"
              type="sentences"
            ></v-skeleton-loader>
          </v-col>

          <v-col
            v-if="showReceipt || showVoucher || transaction.receipt_number"
            no-gutters
            class="px-10 pt-6 b-bottom-outlined"
          >
            <v-col cols="12" class="d-flex" v-if="transaction.receipt_number">
              <v-text-field
                v-model="transaction.receipt_number"
                :label="translations.receiptNumber[lang]"
                color="secondary"
                outlined
                :disabled="isScanned.url"
                dense
                :success="success.receipt"
                :error-messages="error.receipt"
                @focus="error.receipt = ''"
              ></v-text-field>
            </v-col>
            <v-col cols="12" class="d-flex" v-else-if="showReceipt && transaction.user">
              <v-text-field
                v-model="transaction.receipt_identifier"
                :label="translations.receiptIdentifier[lang]"
                color="secondary"
                outlined
                dense
                :disabled="!(superUser || !receiptScanOnly)"
                validate-on-blur
                :success="success.receipt"
                :error-messages="error.receipt"
                @focus="error.receipt = ''"
                @change="validateReceiptInput"
              ></v-text-field>
            </v-col>
            <v-col cols="12" v-if="showVoucher || true">
              <v-col v-if="showNotRegisteredWarning">
                <v-alert dense outlined type="warning" class="my-1 pb-2">
                  <span class="exp-days-description mb-n3">{{
                    translations.mobileRegistrationRequired[lang]
                  }}</span>
                </v-alert>
              </v-col>
              <template v-else>
                <v-text-field
                  v-model="transaction.voucher"
                  :label="translations.voucherCode[lang]"
                  color="secondary"
                  outlined
                  dense
                  clearable
                ></v-text-field>
              </template>
            </v-col>
          </v-col>

          <Products
            v-if="showProducts && transaction.user != null && transaction.user != ''"
            @update-products-success="productsSuccess = $event"
          />

          <div
            v-else-if="!showProducts && transaction.user != null && transaction.user != ''"
            class="px-10 py-6 b-bottom-outlined"
          >
            <v-text-field
              v-model="transaction.amount"
              :label="translations.productAmount[lang]"
              color="secondary"
              class="mt-3"
              outlined
              dense
              :disabled="isScanned.url"
              clearable
              hide-details="auto"
              no-top-margin
              :success="success.amount"
              :error-messages="error.amount"
              @focus="error.amount = ''"
              @blur="validateAmount"
            ></v-text-field>
          </div>
          <div v-if="!previewLoading">
            <v-col v-if="showNotRegisteredWarning">
              <v-col
                cols="12"
                class="subtitle-1 font-weight-bold pb-5"
                v-text="translations.coupons[lang]"
              ></v-col>
              <v-alert dense outlined type="warning" class="my-1 pb-2">
                <span class="exp-days-description mb-n3">{{
                  translations.mobileRegistrationRequired[lang]
                }}</span>
              </v-alert>
            </v-col>
            <template v-else>
              <GeneralCoupons v-if="renderComponent" />

              <SamplingCoupons v-if="renderComponent" />

              <Coupons v-if="renderComponent" />
            </template>
          </div>
          <v-skeleton-loader
            v-else
            min-height="100"
            class="d-flex align-stretch transaction-coupons-loader ma-8 pt-7"
            v-bind="skeletonAttrs"
            type="button@3"
          ></v-skeleton-loader>
          <v-alert v-if="errorMessage" type="error" class="mt-4">{{ errorMessage }}</v-alert>

          <v-col cols="12" class="px-10 pt-7 pb-3 d-flex">
            <v-btn
              class="flex-grow-1"
              type="submit"
              color="secondary"
              depressed
              :loading="loading"
              :disabled="!valid"
              >{{ translations.createOrder[lang] }}
              <span v-if="validationTime" class="px-1">({{ newTransactionCountDown }})</span></v-btn
            >
            <v-btn
              v-if="hasScan"
              class="mx-1"
              color="secondary"
              depressed
              :loading="loading"
              @click="resetScan"
            >
              <v-icon :size="30" color="white" v-text="icons.mdiUndoVariant"></v-icon
            ></v-btn>
          </v-col>
          <div class="px-10 pb-1"></div>
        </v-form>
        <v-form
          autocomplete="off"
          @submit.prevent
          style="position: absolute; z-index: -1; height: 0px; top: 40%"
        >
          <v-text-field ref="scanInput" v-model="scanVal" type="text"></v-text-field>
        </v-form>
      </v-card>
    </v-sheet>

    <v-dialog v-model="smsVerificatonDialog" max-width="500">
      <b-card
        :title="translations.verificationCodeTitle[lang]"
        @cancel="smsVerificatonDialog = false"
        @submit="handleVerificationProcess"
      >
        <div class="subtitle-1 font-weight-medium pl-2">
          {{ translations.verificationCodeDescription[lang] }}
          <b-text-field v-model="verificationCode" type="number"></b-text-field>
        </div>
      </b-card>
    </v-dialog>
    <v-dialog v-model="customerDialog" max-width="700">
      <CustomerForm
        v-if="renderComponent"
        :customerData="customerData"
        :isCustomer="transactionPreview.is_customer"
        :userAccountId="transactionPreview.user_account_id"
        @close="customerDialog = false"
      />
    </v-dialog>

    <div id="point-receipt" ref="pointReceipt">
      <PointReceipt style="padding-bottom: 50px; margin-bottom: 50px" />
    </div>
    <v-dialog v-model="scanAlert" :max-width="$vuetify.breakpoint.smAndDown ? '90%' : '40%'">
      <ScanAlertDialog
        @close="scanAlert = false"
        @submit="getReceiptData"
        :alert-text="this.translations.confirmScanMsg[this.lang]"
        :alert-title="this.translations.confirmScanTitle[this.lang]"
      />
    </v-dialog>
  </v-container>
</template>

<script>
import transactions from '@/store/modules/storePanel/transactions';

import {
  mdiPlusThick,
  mdiQrcodeScan,
  mdiUndoVariant,
  mdiArrowULeftTop,
  mdiInformationOutline,
  mdiAccountDetails,
} from '@mdi/js';
import { mapState, mapMutations, mapActions } from 'vuex';
import debounce from 'lodash/debounce';

import CustomerForm from '@/components/storePanel/transactions/CustomerForm.vue';
import Products from '@/components/storePanel/newTransaction/Products.vue';
import GeneralCoupons from '@/components/storePanel/newTransaction/GeneralCoupons.vue';
import SamplingCoupons from '@/components/storePanel/newTransaction/SamplingCoupons.vue';
import Coupons from '@/components/storePanel/newTransaction/Coupons.vue';
import translations from '@/utils/translations/storePanel/newTransaction';
import validators from '@/utils/validators/storePanel/newTransaction';
import isEmpty from 'lodash/isEmpty';
import { v4 as uuidv4 } from 'uuid';
import PointReceipt from '@/components/storePanel/newTransaction/PointReceipt.vue';
import ScanAlertDialog from '@/components/storePanel/newTransaction/ScanAlertDialog.vue';
import { nextTick } from 'process';

export default {
  name: 'NewTransaction',

  components: {
    Products,
    GeneralCoupons,
    SamplingCoupons,
    Coupons,
    PointReceipt,
    ScanAlertDialog,
    CustomerForm,
  },

  mixins: [translations, validators],

  data: () => ({
    icons: {
      mdiPlusThick,
      mdiQrcodeScan,
      mdiUndoVariant,
      mdiArrowULeftTop,
      mdiInformationOutline,
      mdiAccountDetails,
    },
    productsSuccess: false,
    showVoucher: false,
    alert: true,
    isEmpty: isEmpty,
    verificationCode: '',
    scanAlert: false,
    uuid: null,
    scanVal: '',
    phoneInput: '',
    scanTempVal: '',
    isScanned: {
      url: false,
      receipt: false,
      user: false,
      sku: false,
    },
    validationTime: null,
    receiptCheckPassed: null,
    scannedProduct: {},
    customerDialog: false,
    renderComponent: true,
    skeletonAttrs: {
      class: 'mb-2',
      boilerplate: true,
      elevation: 0,
    },
  }),

  computed: {
    ...mapState(['loading', 'errorMessage', 'superUser', 'activeCountries']),
    ...mapState('storePanel', ['store', 'company']),
    ...mapState('storePanel/transactions', [
      'previewLoading',
      'generalCouponClaims',
      'coupons',
      'samplingCoupons',
      'products',
    ]),

    lang() {
      return this.$route.params.lang;
    },
    storeMode() {
      return this.$store.state.store?.display_mode || 'points';
    },
    smsVerificatonDialog: {
      get() {
        return this.$store.state.storePanel.transactions.smsVerificatonDialog;
      },

      set(val) {
        this.setSmsVerificatonDialog(val);
      },
    },

    permission() {
      return this.$store.state.permissions.transactions
        ? this.$store.state.permissions.transactions.create
        : this.superUser;
    },

    showReceipt() {
      return this.$store.state.storePanel.store.flags.reward.offline_transaction_receipt;
    },
    receiptScanOnly() {
      return this.$store.state.storePanel.store.flags.reward.offline_transaction_receipt_scan;
    },

    showProducts() {
      return this.$store.state.storePanel.store.flags.reward.offline_transaction_products;
    },

    twoFactorAuth() {
      return this.$store.state.storePanel.store.flags.reward.offline_two_factor_authentication;
    },

    couponsExist() {
      return (
        this.generalCouponClaims.length + this.coupons.length + this.samplingCoupons.length > 0
      );
    },

    selectedProducts: {
      get() {
        return this.$store.state.storePanel.transactions.selectedProducts;
      },
      set(val) {
        this.setSelectedProducts(val);
      },
    },

    transactionPreview: {
      get() {
        return this.$store.state.storePanel.transactions.transactionPreview;
      },

      set(val) {
        this.setTransactionPreview(val);
      },
    },

    transaction: {
      get() {
        return this.$store.state.storePanel.transactions.transaction;
      },

      set(val) {
        this.setItem(val);
      },
    },

    customerData: {
      get() {
        return this.$store.state.storePanel.transactions.customerData;
      },

      set(val) {
        this.setCustomerData(val);
      },
    },
    formInputs: {
      get() {
        return this.getFormInputs();
      },
    },
    newTransactionCountDown: {
      get() {
        if (!this.validationTime) return '';
        let minutes = Math.floor(this.validationTime / 60);
        let seconds = this.validationTime - minutes * 60;
        return `${minutes}:${seconds < 10 ? '0' + seconds : seconds}`;
      },
    },
    hasScan() {
      let scan = false;
      for (let type in this.isScanned) {
        scan = scan || this.isScanned[type];
      }
      return scan;
    },
    showCustomerData() {
      return (
        this.twoFactorAuth &&
        this.success.user &&
        this.transaction.user.length > 7 &&
        this.transactionPreview.user_points_info !== undefined
      );
    },
    showNotRegisteredWarning() {
      return (
        !this.error?.user &&
        this.transactionPreview.user_account_id &&
        !this.transactionPreview.has_phone_number
      );
    },
  },

  methods: {
    getFormInputs(children) {
      let inputs = [];
      children = children || (this.$refs.transactionForm && this.$refs.transactionForm.$children);
      if (children) {
        inputs = children.filter((e) => e.$_modelEvent === 'input');
        for (let child of children) {
          if (child.$_modelEvent !== 'input' && child.$children && child.$children.length) {
            inputs = [...inputs, ...this.getFormInputs(child.$children)];
          }
        }
      }
      return inputs;
    },

    ...mapMutations(['setLoading', 'setNotification']),
    ...mapMutations('storePanel/transactions', [
      'setTransactionPreview',
      'setItem',
      'setSmsVerificatonDialog',
      'setSelectedProducts',
      'setCustomerData',
    ]),
    ...mapActions(['loadActiveCountries']),
    ...mapActions('storePanel/transactions', [
      'create',
      'getTransactionPreview',
      'sendVerificationCode',
      'fetchReceiptData',
      'validateReceipt',
      'getProducts',
      'getProductFromSku',
      'getAttributes',
    ]),

    handleGetTransactionPreview() {
      this.getTransactionPreview(false);
      this.forceRerender();
    },
    handleFocus() {
      let inputs = this.getFormInputs();
      let focused = false;
      for (let input of inputs) {
        focused = focused || input.isFocused;
      }
      if (!focused) {
        this.$refs.scanInput.focus();
      }
    },
    countDownTimer(time) {
      if (time) this.validationTime = time;
      if (this.validationTime > 0) {
        setTimeout(() => {
          if (this.isScanned.url || this.isScanned.receipt) {
            this.validationTime -= 1;
            this.countDownTimer();
          }
        }, 1000);
      } else if (!Number.isNaN(this.validationTime) && this.validationTime <= 0) {
        this.resetScan();
        if (this.transaction.receipt_identifier) this.transaction.receipt_identifier = '';
        let error = {
          el: 'Λήξη χρόνου. Παρακαλώ συμπληρώστε ξανά την φόρμα.',
          en: 'Time out. Please fill in the form again.',
          it: 'Tempo scaduto. Compilare nuovamente il modulo.',
        };
        return this.setNotification({
          show: true,
          type: 'error',
          text: error[this.lang],
        });
      } else if (!this.isScanned.url || this.isScanned.receipt) {
        this.validationTime = null;
      }
    },

    async createTransaction() {
      if (!this.loading) {
        if (this.store.flags.reward.thermal_printer) {
          await this.printPointReceipt();
        }
        this.uuid = await uuidv4();
        if (this.transactionPreview.is_customer === false) {
          this.transaction.company_information = this.customerData;
        }
        await this.create(this.uuid);
        this.resetScan();
      }
    },

    async getScannedSku(sku) {
      let productIsScanned = false;
      let product = this.scannedProduct;
      if (product) {
        product.selected = true;
        let previewSelectedProduct = this.transactionPreview.products.find(
          (x) => x.product_id == product.product_id
        );
        if (!previewSelectedProduct) {
          this.transactionPreview.products.push(product);
        } else if (product.reward_type_id == 3) {
          previewSelectedProduct.quantity = Number(previewSelectedProduct.quantity) + 1;
        }
        let selectedProduct = this.selectedProducts.find((x) => x.product_id == product.product_id);
        if (!selectedProduct) {
          this.setSelectedProducts([...this.selectedProducts, product]);
          productIsScanned = true;
        } else if (product.reward_type_id == 3) {
          let transactionProduct = this.transaction.products.find(
            (x) => x.product_id == product.product_id
          );
          productIsScanned = true;
          selectedProduct.quantity = Number(selectedProduct.quantity) + 1;
          transactionProduct.quantity = Number(transactionProduct.quantity) + 1;
        }
      } else {
        this.setNotification({
          show: true,
          type: 'error',
          text: this.translations.scanNotFound[this.lang],
        });
      }
      this.scanVal = '';
      return productIsScanned;
    },

    async removeScannedValue(scanVal, input, type) {
      let field = '';
      for (let prop in this.transaction) {
        if (!!input && this.transaction[prop] == input._value) {
          field = prop;
        }
        // else{
        // }
      }
      this.transaction[field] = ('' + this.transaction[field]).replace(scanVal, '');
      let isNumber = !isNaN(parseFloat(this.transaction[field])) && field != 'user';
      this.transaction[field] = !isNumber
        ? this.transaction[field]
        : parseFloat(this.transaction[field]);
    },

    async decideScanType(val) {
      this.scannedProduct = await this.getProductFromSku(val);
      let urlIndex = !!val && (' ' + val).indexOf('https://');
      let isPositiveInt = parseInt(val) + '' == val && parseInt(val) > 0;
      if (urlIndex > 0) return 'url';
      if (this.transaction.user == val && isPositiveInt && val.length >= 5 && val.length <= 10)
        return 'user';
      if (this.showProducts && this.scannedProduct && this.transaction.user) return 'sku';
      if (isPositiveInt) return 'receipt';
      return '';
    },

    async checkReceiptData(data) {
      this.receiptCheckPassed = true;
      this.validationTime = null;
      let validationData = await this.validateReceipt(data);
      if (!validationData || validationData.error) {
        this.resetScan();
        if (data.receipt_identifier) this.transaction.receipt_identifier = '';
        if (validationData.message == 'CASH_REGISTER_CODE_DOES_NOT_EXIST_IN_STORE') {
          validationData.errorMessage = {
            el: 'H ταμειακή μηχανή δεν υπάρχει στο κατάστημα.',
            en: 'Cash register does not exists in store.',
            it: 'Il registratore di cassa non esiste in negozio.',
          }[this.lang];
        }
        this.setNotification({
          show: true,
          type: 'error',
          text:
            (validationData && (validationData.error[this.lang] || validationData.errorMessage)) ||
            'ERROR',
        });
        this.receiptCheckPassed = false;
      }
      this.transaction.receipt_validation_needed =
        !!this.transaction.receipt_number || !!this.transaction.receipt_identifier;
      if (!validationData.data.is_unique) {
        this.resetScan();
        let error = {
          el: 'Αυτή η απόδειξη έχει ήδη καταχωρηθεί στο σύστημα.',
          en: 'This receipt has already been registered in the system.',
          it: 'Questa ricevuta è già stata registrata nel sistema.',
        };
        this.setNotification({
          show: true,
          type: 'error',
          text: error[this.lang],
        });
        this.receiptCheckPassed = false;
      }
      if (validationData.data.valid_for_minutes > 0)
        this.countDownTimer(validationData.data.valid_for_minutes * 60);
      return this.receiptCheckPassed;
    },

    async getReceiptData(url) {
      let data = await this.fetchReceiptData(url);
      if (data.error) {
        return this.setNotification({
          show: true,
          type: 'error',
          text: data.error[this.lang],
        });
      }
      this.transaction.receipt_number = data.receipt_number;
      this.transaction.cash_register_code = data.cash_register_code;
      this.transaction.receipt_identifier = '';
      this.scanVal = '';
      if (!this.showProducts) {
        this.transaction.amount = data.amount;
      } else if (this.transaction.products?.length === 1) {
        this.transaction.products[0].retail_price = data.amount;
      } else if (!this.transaction.products?.length) {
        this.resetScan();
        let error = {
          el: 'Η σάρωση αποδείξεων δεν είναι δυνατή όταν δεν υπάρχει επιλεγμένο προϊόν.',
          en: 'Receipt scanning is not possible when there is no selected product.',
          it: "La scansione dello scontrino non è possibile se non c'è un prodotto selezionato.",
        };
        return this.setNotification({
          show: true,
          type: 'error',
          text: error[this.lang],
        });
      }
      await this.checkReceiptData(data);

      this.scanAlert = false;
    },

    async resetScan() {
      this.setLoading(false);
      if (this.isScanned.url) {
        this.isScanned.url = false;
        this.transaction.amount = '';
        this.transaction.receipt_number = '';
        this.transaction.cash_register_code = '';
        this.transaction.receipt_validation_needed = false;
        this.$nextTick(() => {
          this.validationTime = null;
        });
      }
      if (this.isScanned.receipt) {
        this.isScanned.receipt = false;
        this.transaction.receipt_identifier = '';
        this.transaction.receipt_validation_needed = false;
        this.$nextTick(() => {
          this.validationTime = null;
        });
      }
      if (this.isScanned.user) {
        this.isScanned.user = false;
        this.transaction.user = '';
      }
      if (this.isScanned.sku) {
        this.isScanned.sku = false;
        this.transaction.products = [];
        this.setSelectedProducts([]);
        this.transactionPreview.products = [];
      }
      this.handleFocus();
    },
    async scan(sScancode, iQuantity) {
      await this.beginScanProcess(sScancode);
    },

    async beginScanProcess(scan) {
      let input = scan.explicitOriginalTarget || scan.srcElement.activeElement;
      // if(!input)
      //     input =
      let scanVal = scan.detail.scanCode;
      let type = await this.decideScanType(scanVal);
      this.isScanned[type] = true;
      await this.removeScannedValue(scanVal, input);
      if (type === 'user') {
        this.error.user = '';
        this.transaction.user = scanVal;
        this.validateUser();
      }
      if (type === 'url') {
        this.getReceiptData(scanVal);
      }
      if (type === 'sku') {
        this.getScannedSku(scanVal);
      }
      if (type === 'receipt') {
        this.error.receipt = '';
        this.transaction.receipt_identifier = scanVal;
        this.validateReceiptInput();
      }
    },

    keyboardEvent(e) {
      console.log(e);
    },
    async printPointReceipt() {
      const printThis = window.open(
        '',
        '',
        'left=0,top=0,width=800,height=900,toolbar=1,scrollbars=1,status=0'
      );
      printThis.document.write('<!DOCTYPE html><html><head><title></title>');
      printThis.document.write(
        '</head><body style="width=100%;height=100%;margin: 50px 0 50px 0; margin-bottom:200px;>'
      );
      if (this.$refs.pointReceipt) printThis.document.write(this.$refs.pointReceipt.innerHTML);
      printThis.document.write('</body></html>');
      printThis.document.close(); // necessary for IE >= 10
      printThis.focus(); // necessary for IE >= 10*/
      printThis.print();
      printThis.close();
      return true;
    },
    async handleVerificationProcess() {
      await this.sendVerificationCode({
        verificationCode: this.verificationCode,
        uuid: this.uuid,
      });
      this.verificationCode = '';
    },
    forceRerender() {
      this.renderComponent = false;
      this.$nextTick(() => {
        this.renderComponent = true;
      });
    },
    getPointsPerLoyalty(type, id) {
      let points = this.transactionPreview[`${type}_user_points_per_loyalty`]?.find(
        (x) => x.loyalty_program_id == id
      );
      return points?.current_balance || 0;
    },
  },

  watch: {
    permission(val) {
      if (!val && !this.superUser) {
        this.$router.replace(`/${this.lang}/storePanel/forbidden-gateway`);
      }
    },

    ['transaction.user'](val) {
      // this.resetScan()
      if (val) {
        this.customerData.mobile = val;
        this.debouncedGetTransactionPreview(this.showProducts);
      } else {
        this.customerData.mobile = '';
        this.customerData.country_id = null;
      }
      this.forceRerender();
    },

    ['customerData.country_id'](val) {
      if (
        this.transactionPreview?.user?.country_id &&
        val != this.transactionPreview.user.country_id
      ) {
        val = this.transactionPreview.user.country_id;
      } else {
        val = val || this.store.country?.country_id;
      }
    },

    ['transaction.country_id'](val) {
      let id = Number(val);
      if (!val || isNaN(id)) {
        this.transaction.country_id = this.store?.country?.country_id || 1;
      }
    },

    ['transactionPreview.user.country_id'](val) {
      let id = Number(val);
      if (val && !isNaN(id)) {
        this.transaction.country_id = id;
      }
    },
    ['store.country.country_id'](val) {
      let id = Number(val);
      if (val && !isNaN(id)) {
        this.transaction.country_id = this.transaction.country_id || id;
      }
    },

    ['transaction.amount'](val) {
      if (val) this.debouncedGetTransactionPreview();
      this.forceRerender();
    },

    ['transaction.products']: {
      async handler(val, preval) {
        if (preval?.length !== val?.length) {
          this.productsSuccess = false;
          if (preval?.length !== 1 && val?.length === 1) {
            this.handleFocus();
          }
        }
      },
      deep: true,
    },

    productsSuccess(val) {
      if (val) {
        this.$nextTick(() => {
          this.$refs.scanInput.focus();
        });
      }
    },
  },

  beforeCreate() {
    if (!this.$store.state.storePanel.transactions) {
      this.$store.registerModule(['storePanel', 'transactions'], transactions);
    }
  },

  created() {
    this.debouncedGetTransactionPreview = debounce(this.handleGetTransactionPreview, 500);
  },

  mounted() {
    this.$clearFocus();
    this.setLoading(false);
    this.$nextTick(() => {
      this.getFormInputs();
    });
    document.addEventListener('scan', this.scan);
    this.getAttributes();
    if (!this.countries?.length) this.loadActiveCountries();
    this.transaction.country_id = this.store.country.country_id;
  },

  beforeDestroy() {
    this.transactionPreview = {};
    this.transaction = {};
    document.removeEventListener('scan', this.scan);
  },
};
</script>
<style>
@media screen {
  #point-receipt {
    display: none !important;
  }
}

@media print {
  #point-receipt {
    display: flex !important;
    margin: 0;
    size: 48mm;
  }

  html,
  body {
    height: 99%;
    margin: 0;
    size: 48mm;
    /* page-break-after: always; */
  }
}
@page {
  margin: 5mm;
  padding-bottom: 5cm;
  /* page-break-after: always; */
  /* position: relative; */
  size: 48mm;
}
.legend100 legend {
  width: 90% !important;
}

.transaction-coupons-loader .v-skeleton-loader__button.v-skeleton-loader__bone {
  min-height: 50px;
  min-width: 160px;
  margin: 10px;
}

.transaction-avatar-loader .v-skeleton-loader__avatar.v-skeleton-loader__bone {
  margin-bottom: 12px;
  margin-top: 12px;
  width: 123px;
  height: 123px;
}

.country-code-select .v-input__slot {
  min-width: 110px;
  padding: 0 4px 0 8px !important;
}
.country-code-select .v-select__selections input {
  padding: 0 !important;
  margin: 0 !important;
  height: 0 !important;
  width: 0 !important;
  overflow: hidden !important;
}

.country-code-select .v-input__append-inner {
  padding-left: 0 !important;
}

.country-code-select .v-input__append-inner .v-icon.v-icon::after {
  max-width: 20px;
  min-width: 20px;
}

.country-code-select fieldset {
  border-right: 1px dotted black !important;
  border-top-right-radius: 0px;
  border-bottom-right-radius: 0px;
}
.user-mobile fieldset {
  border-left: none !important;
  border-top-left-radius: 0px;
  border-bottom-left-radius: 0px;
}
.mobile-cc-container .v-text-field__details {
  height: 25px;
}
</style>
